import { render, staticRenderFns } from "./BookingSpaceoceanShipping.vue?vue&type=template&id=ddd5fdc6&scoped=true&"
import script from "./BookingSpaceoceanShipping.vue?vue&type=script&lang=js&"
export * from "./BookingSpaceoceanShipping.vue?vue&type=script&lang=js&"
import style0 from "./BookingSpaceoceanShipping.vue?vue&type=style&index=0&id=ddd5fdc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd5fdc6",
  null
  
)

export default component.exports